// @ts-check
import * as React from "react"
import {QueryClientProvider} from "@tanstack/react-query"

import {config} from "../../config"

/**
 * @type {React.FC<{
 *   children: React.ReactNode,
 * }>}
 */
const QueryProvider = ({children}) => {
  return (
    // Provide the client to your App
    <QueryClientProvider client={config.queryClient}>
      {children}
    </QueryClientProvider>
  )
}

export {QueryProvider}
